module.exports = __webpack_public_path__ + "static/media/8.1f2e370c.jpg";